import { useUpdateUserDetailsMutation } from 'util/rtk-api'
import { setCache } from 'util/cache'
import { showToast } from 'components/toast'
import { showMutationError } from 'util/mutation-error'

import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'

/**
 * @module settings/settings-input
 * @description An editable settings field: click "Edit", the input
 * becomes focusable, blurring saves the new value (PATCH-on-blur). If
 * `to` is passed instead of `onChange` (the Password field's shape), the
 * label becomes a real navigation link instead of an inline editor.
 */
export const SettingsInput = ({
	label,
	name,
	value,
	onChange,
	format,
	to,
}) => {
	const inputRef = useRef()
	const [ updateUserDetails ] = useUpdateUserDetailsMutation()

	const [ editable, setEditable ] = useState(false)

	const voidFunc = () => {}

	const onBlur = async ({ target }) => {
		const formatted = format ? format(value) : value

		setEditable(false)

		if (!target.checkValidity()) {
			showToast(`Invalid value entered. ${target.validationMessage}`)
			return
		}

		const result = await updateUserDetails({ [name]: value })

		if (showMutationError(result)) return

		setCache({
			[name]: value,
		})
	}

	const onKeyPress = e => {
		if (e.key !== 'Enter') return

		e.target.blur()
	}

	useEffect(() => {
		editable && inputRef.current.focus()
	}, [editable])

	return (
		<div className="settings-item">
			<div className="field-label-container">
				<span className="field-label">{label}</span>
				<Link
					to={to}
					className="edit-link"
					onClick={() => setEditable(true)}
				>
					Edit
				</Link>
			</div>
			<input
				ref={inputRef}
				className={`field-value ${editable ? 'editable' : ''}`}
				name={name}
				value={(format ? format(value) : value) || ''}
				onChange={onChange || voidFunc}
				onBlur={onBlur}
				onKeyPress={onKeyPress}
			/>
		</div>
	)
}

export default SettingsInput
